export default __webpack_public_path__ + "static/media/mark-read.d62251e2.svg";